import type { CrudArgs } from "./composables/ContextVoter";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

/** The item a pin is on; shared pins are allowed per location of that item. */
export type PinSubjectVote = Pick<CrudArgs, "location">;

/**
 * Mirrors the API PinAttribute: personal pins only need read access to the item, which the item being on
 * screen already proves. Shared pins change the lists of everyone at the item's location, so setting and
 * removing them are permissions of their own on that location.
 */
export class PinVoter extends ContextVoter {
  public canCreateShared(item: PinSubjectVote): boolean {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPinCreatesharedany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPinCreateshared,
    });
  }

  public canDeleteShared(item: PinSubjectVote): boolean {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPinDeletesharedany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPinDeleteshared,
    });
  }
}
